import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-restricted',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
